import PrivacyPage from '../components/pages/PrivacyPage';
import withTranslate from '../components/withTranslate';

export default withTranslate(PrivacyPage);
